export default "__VITE_ASSET__8cf0b529__"